import type { ConfigRequest } from '@pba/react-utils';
import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type UsersParams = {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
  community_ids: string[];
  cursor?: string;
  limit?: number;
  // TODO this should be type
  role?: 'admin' | 'member';
  scope: 'communities';
  search?: string;
};

export const getCommunityUsersAutocomplete = async ({ config }: ConfigRequest<UsersParams>) =>
  apiClient.get<Array<components['schemas']['UserList']>, ApiClientResponse<Array<components['schemas']['UserList']>>>(
    routes.community.autoComplete,
    config,
  );
